<template>
  <div class="container pt-3" style="max-width: 380px;">
    <div class="card mt-5">
      <div class="card-header" style="background-color: #10638F;">
        <div class="text-white h4 w-100 mx-0 my-0">{{ $t('nav-contact-us') }}</div>
      </div>
      <div class="card-body">
        <div class="h4" v-html="$t('add-line-at')"></div>
        <p class="card-text">
        <ul class="list-group list-group-flush pt-0 mt-0 ">
          <li class="list-group-item pb-3">
            <div><b> ID: @356vawoa </b></div>
            <div>
              <a href="https://lin.ee/vqfTBsa" target="_blank"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png" alt="加入好友" height="36"></a>
            </div>
          </li>
          <li class="list-group-item">
            <h4 class="card-title">Email</h4>
            <div>
              <b>elcodingstudio@gmail.com</b>
            </div>
          </li>
        </ul>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
  },
}
</script>
<style>
</style>